import { render, staticRenderFns } from "./text-mask.vue?vue&type=template&id=af7e1c7a"
import script from "./text-mask.vue?vue&type=script&lang=js"
export * from "./text-mask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports